import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { CartProvider } from "@/context/CartContext";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import CartDrawer from "@/components/CartDrawer";
import CountdownBanner from "@/components/CountdownBanner";
import LiveBanner from "@/components/LiveBanner";
import Home from "@/pages/Home";
import Store from "@/pages/Store";
import ProductDetail from "@/pages/ProductDetail";
import PaymentSuccess from "@/pages/PaymentSuccess";
import OrderLookup from "@/pages/OrderLookup";
import Academy from "@/pages/Academy";
import AcademyGift from "@/pages/AcademyGift";
import GiftClaim from "@/pages/GiftClaim";
import Circles from "@/pages/Circles";
import Reader from "@/pages/Reader";
import Dictionary from "@/pages/Dictionary";
import Quiz from "@/pages/Quiz";
import MatchGame from "@/pages/MatchGame";
import Admin from "@/pages/Admin";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const SmoothScroll = () => {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);
  return null;
};

function App() {
  return (
    <div className="App grain">
      <BrowserRouter>
        <CartProvider>
          <SmoothScroll />
          <ScrollToTop />
          <Nav />
          <CountdownBanner />
          <LiveBanner />
          <CartDrawer />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/store" element={<Store />} />
            <Route path="/product/:id" element={<ProductDetail />} />
            <Route path="/academy" element={<Academy />} />
            <Route path="/academy/gift" element={<AcademyGift />} />
            <Route path="/gift/:code" element={<GiftClaim />} />
            <Route path="/circles" element={<Circles />} />
            <Route path="/read" element={<Reader />} />
            <Route path="/read/quiz/:chapterId" element={<Quiz />} />
            <Route path="/read/game" element={<MatchGame />} />
            <Route path="/dictionary" element={<Dictionary />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/orders" element={<OrderLookup />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
          </Routes>
          <Footer />
          <Toaster
            position="bottom-right"
            toastOptions={{
              style: {
                background: "#0F3821",
                color: "#FAFAFA",
                border: "1px solid #D4AF37",
                borderRadius: "2px",
                fontFamily: "Outfit, sans-serif",
              },
            }}
          />
        </CartProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
